module.exports = __webpack_public_path__ + "static/media/MMC-LOGO.49a3500c.jpg";